import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, { elevation: 2 }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "navBarOptions"),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        "prepend-icon": _ctx._theme === 'light' ? 'mdi-weather-sunny' : 'mdi-weather-night',
        onClick: _ctx.toggleTheme
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx._theme), 1)
        ]),
        _: 1
      }, 8, ["prepend-icon", "onClick"])
    ]),
    _: 3
  }))
}